const CONNECTOR_AUTH_FAILED = { message: "Connector authentication failed", severity: "warn", status: 401, service: "connector" };
const CONNECTOR_REFRESH_FAILED = { message: "OAuth token refresh failed", severity: "warn", status: 401, service: "connector" };
const CONNECTOR_EXEC_FAILED = { message: "Connector execution failed", severity: "error", status: 502, service: "connector" };
/**
 * A protocol action (DB, SFTP, FTPS, MSSQL, MongoDB) reached a runtime that
 * cannot run it.
 *
 * These families need a real Node runtime -- their drivers reach into node
 * internals -- so they execute in `services/connector/src/executor.ts`, which
 * ships as a Cloudflare Container bound to UCL's Worker. Where that container
 * is not wired up, UCL refuses the action.
 *
 * 503, not 502: nothing is broken and retrying the same call will not help.
 * The capability is absent from this environment, which is an operator fact,
 * and `severity: warn` keeps it off the paging path for exactly that reason.
 */
const CONNECTOR_PROTOCOL_UNAVAILABLE = { message: "Protocol executor unavailable", severity: "warn", status: 503, service: "connector" };
/** Connector service codes. Canonical `CONN-*`; legacy flat names kept as aliases. */
export const CONNECTOR_ERRORS = {
    "CONN-AUTH-FAILED": CONNECTOR_AUTH_FAILED,
    "CONN-REFRESH-FAILED": CONNECTOR_REFRESH_FAILED,
    "CONN-EXEC-FAILED": CONNECTOR_EXEC_FAILED,
    "CONN-PROTOCOL-UNAVAILABLE": CONNECTOR_PROTOCOL_UNAVAILABLE,
    CONNECTOR_AUTH_FAILED,
    CONNECTOR_REFRESH_FAILED,
    CONNECTOR_EXEC_FAILED,
    CONNECTOR_PROTOCOL_UNAVAILABLE,
};
//# sourceMappingURL=connector.js.map